<script setup>

import {
  LanguageIcon,
  LockClosedIcon,
  ShieldCheckIcon,
  StarIcon,
  UserIcon,
} from '@heroicons/vue/24/outline';
import IncentiveCard from '@/components/landing/IncentiveCard.vue';
import InboxCustomizeIcon from '@/components/CustomIcons/InboxCustomizeIcon.vue';
</script>

<template>

  <div class="bg-primary text-basecolor py-8 px-6">
    <div class="mx-auto max-w-7xl p-10">
      <div class="mx-auto max-w-3xl px-4 lg:max-w-none">
        <div class="max-w-4xl">
          <h2 class="text-3xl font-bold tracking-tight">
            {{ $t('landingPage.whySection.incentivesTitle') }}
          </h2>
        </div>
        <div class="mt-16 grid grid-cols-1 gap-x-16 gap-y-10 lg:grid-cols-3">
          <IncentiveCard
            :icon="StarIcon"
            :title="$t('landingPage.whySection.incentives[0].title')"
            :desc="$t('landingPage.whySection.incentives[0].text')"
          />
          <IncentiveCard
            :icon="UserIcon"
            :title="$t('landingPage.whySection.incentives[1].title')"
            :desc="$t('landingPage.whySection.incentives[1].text')"
          />
          <IncentiveCard
            :icon="ShieldCheckIcon"
            :title="$t('landingPage.whySection.incentives[2].title')"
            :desc="$t('landingPage.whySection.incentives[2].text')"
          />
          <IncentiveCard
            :icon="LanguageIcon"
            :title="$t('landingPage.whySection.incentives[3].title')"
            :desc="$t('landingPage.whySection.incentives[3].text')"
          />
          <IncentiveCard
            :icon="InboxCustomizeIcon"
            :title="$t('landingPage.whySection.incentives[4].title')"
            :desc="$t('landingPage.whySection.incentives[4].text')"
          />
          <IncentiveCard
            :icon="LockClosedIcon"
            :title="$t('landingPage.whySection.incentives[5].title')"
            :desc="$t('landingPage.whySection.incentives[5].text')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
